export enum PublicFlowEnum {
	SIGN_UP = 'signUp',
	FORGOT_PASSWORD = 'forgotPassword',
}
